var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrailer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "&ns_svg;",
    xmlnsXlink: "&ns_xlink;",
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    overflow: "visible",
    enableBackground: "new 0 0 144 144",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trailer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trailer_1_",
    fill: "#a55da1",
    d: "M70.867,2.268C31.728,2.268,0,33.996,0,73.134C0,112.272,31.728,144,70.867,144 c39.137,0,70.866-31.728,70.866-70.866C141.732,33.996,110.004,2.268,70.867,2.268z M97.511,28.414 c6.672-1.729,9.719-0.29,11.624,7.063l0.983,3.797l-4.646,1.204l-11.219-11.22L97.511,28.414z M68.13,59.917h14.13l-7.127,12.917 H61.003L68.13,59.917z M54.867,72.834H40.929l7.127-12.917h13.938L54.867,72.834z M88.397,59.917h14.08L95.35,72.834H81.27 L88.397,59.917z M88.62,30.717l11.219,11.22L86.08,45.501L74.86,34.282L88.62,30.717z M69.227,35.742l11.219,11.22l-13.958,3.616 l-11.22-11.22L69.227,35.742z M36.163,44.308l13.472-3.491l11.22,11.22l-13.692,3.547L35.947,44.369 C36.021,44.349,36.088,44.328,36.163,44.308z M31.017,46.532l10.513,10.513l-11.085,2.872H41.92l-7.127,12.917h-4.375v-12.91 l-0.001,0l-0.983-3.798C28.167,51.242,28.621,48.4,31.017,46.532z M112.667,103.295c0,7.595-3.588,10.752-10.479,10.752H40.813 c-6.893,0-10.48-3.157-10.48-10.752V76.372h82.333V103.295z M112.667,72.834h-11.181l7.128-12.917h4.053V72.834z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailer);
export default __webpack_public_path__ + "static/media/trailer.ccd889ff.svg";
export { ForwardRef as ReactComponent };